import React, { FC } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { EntityTypeEnum, WorkflowActions } from 'api'
import { Locale, Translation } from 'locale'
import { CorrelatedResponseCallback, EntityTypeIdRecord } from 'store/notification/notificationTypes'
import { downloadUrl } from 'utils'
import collateralUploadTemplateUrl from './assets/CollateralUploadTemplate.xlsx'
import { canManageCollateralsSelector } from 'selectors/permissionSelectors'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { ActionItem, SplitButtonDropdown, SplitButtonType } from 'view/components/menus'
import { CollateralDialogEdit } from './CollateralDialog'
import { CollateralUploadDialog } from 'view/shared/collateralUpload'

export interface CollateralToolbarProps extends ModalConsumerProps {
  canManageCollaterals: boolean
  onAddNewCollateral: (entityTypeEnum: EntityTypeEnum, correlatedResponseCallback?: CorrelatedResponseCallback) => unknown
}

const mapStateToProps = createStructuredSelector({
  canManageCollaterals: canManageCollateralsSelector
})

const mapDispatchToProps = {
  onAddNewCollateral: WorkflowActions.createNewWorkflow
}

const SplitButtonStyled = styled(SplitButtonDropdown)`
  max-width: 140px;
`

export const CollateralToolbarComponent: FC<CollateralToolbarProps> = props => {
  const { canManageCollaterals, showModal, onAddNewCollateral } = props
  if (!canManageCollaterals) {
    return null
  }

  const handleAddButtonClick = () => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      showModal(
        <CollateralDialogEdit
          workflowId={workflowId}
          collateralEntityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.COLLATERAL]}
          collateralPriceEntityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.COLLATERAL_PRICE]}
        />
      )
    }
    onAddNewCollateral(EntityTypeEnum.COLLATERAL, correlatedResponseCallback)
  }

  const handleUploadSpreadsheet = () => {
    showModal(<CollateralUploadDialog />)
  }

  const handleDownloadSpreadsheet = () => {
    downloadUrl(collateralUploadTemplateUrl, Locale.translate(Translation.TC_DOWNLOAD_COLLATERAL_TEMPLATE_FILENAME))
  }

  const toolbarActions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_BUTTON_NEW_COLLATERAL),
      type: SplitButtonType.Primary,
      onClick: handleAddButtonClick,
      enabled: true
    },
    {
      label: Locale.translate(Translation.TC_ACTION_UPLOAD_SPREADSHEET),
      type: SplitButtonType.Primary,
      onClick: handleUploadSpreadsheet,
      enabled: true
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DOWNLOAD_SPREADSHEET),
      type: SplitButtonType.Primary,
      onClick: handleDownloadSpreadsheet,
      enabled: true
    }
  ]

  return <SplitButtonStyled dataTestId={'CollateralToolbar-TextButton-ButtonNewCollateral'} actions={toolbarActions} maxButtons={1} />
}

export const CollateralToolbar = withModal(connect(mapStateToProps, mapDispatchToProps)(CollateralToolbarComponent))
